import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { type StudioDetails } from '~entities/studios/model/types';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const getDashboardStatusAPI = async (): Promise<StudioDetails> => {
  const response = await baseAPI.get<StudioDetails>(
    '/studios/new-dashboard-status',
  );
  return response.data;
};

export const useGetDashboardStatus = (
  options?: Omit<UseQueryOptions<StudioDetails>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<StudioDetails>({
    queryKey: [KEYS.DASHBOARD_STATUS],
    queryFn: () => getDashboardStatusAPI(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options,
  });
};
